// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2HirH","cancelIcon":"styles_cancelIcon__BegY_","textCont":"styles_textCont__Fak_7","hidden":"styles_hidden__2hDKs"};